import type { GlobalToken } from 'antd';

/**
 * How one outcome row reads at a glance. Deliberately status-agnostic: each
 * feature maps its own backend enum onto these four, and only that mapping
 * has to be reviewed when the enum grows.
 */
export type OutcomeTone = 'success' | 'warning' | 'error' | 'neutral';

/** Background, border and icon fill for a tone. */
export interface OutcomeToneTokens {
  bg: string;
  border: string;
  icon: string;
}

export const outcomeToneTokens = (
  tone: OutcomeTone,
  token: GlobalToken
): OutcomeToneTokens =>
  ({
    success: {
      bg: token.colorSuccessBg,
      border: token.colorSuccessBorder,
      icon: token.colorSuccess,
    },
    warning: {
      bg: token.colorWarningBg,
      border: token.colorWarningBorder,
      icon: token.colorWarning,
    },
    error: {
      bg: token.colorErrorBg,
      border: token.colorErrorBorder,
      icon: token.colorError,
    },
    neutral: {
      bg: token.colorFillQuaternary,
      border: token.colorBorderSecondary,
      icon: token.colorTextTertiary,
    },
  })[tone];
